@if (isInitialized) {
  <oe-flat-widget
    button
    (click)="presentModal()"
    [title]="'EDGE.INDEX.WIDGETS.COST_REVENUE.TITLE' | translate"
    [icon]="{name:'cash-outline', color: 'normal', size: 'large'}">

    <oe-flat-widget-line
      [name]="'EDGE.INDEX.WIDGETS.COST_REVENUE.DAILY_TOTAL_COST' | translate"
      [channelAddress]="componentId + '/DailyActualTotalCost'"
      [converter]="eurConverter">
    </oe-flat-widget-line>

    <oe-flat-widget-line
      [name]="'EDGE.INDEX.WIDGETS.COST_REVENUE.DAILY_SAVINGS' | translate"
      [channelAddress]="componentId + '/DailyCashflowSavingsVsAllFromGrid'"
      [converter]="eurConverter">
    </oe-flat-widget-line>

  </oe-flat-widget>
}
